<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  <div [innerHtml]="signupSuccessText"></div>
</mat-dialog-content>
<mat-dialog-actions>

  <button matButton [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
